<a href="/campaigns/{{campaign_id}}/progress/{{id}}" title="{{name}}" class="list-group-item">
    <h5>
        <span class="text-muted">#{{id}}</span> {{name}}
    </h5>
</a>
